import { useConn } from "../store/useConn";

const LABELS = {
  connecting: { text: "подключение…", color: "#eab308" },
  open: { text: "сокет активен", color: "var(--color-buy)" },
  closed: { text: "нет связи", color: "var(--color-sell)" },
} as const;

/** Состояние торгового сокета. Оператор должен видеть его всегда: молча
 *  отвалившееся соединение выглядит как «рынок замер», а это разные вещи. */
export function ConnectionBadge() {
  const connection = useConn((s) => s.connection);
  const received = useConn((s) => s.received);
  const label = LABELS[connection];

  return (
    <div className="flex items-center gap-2 text-xs">
      <span
        className="inline-block h-2 w-2 rounded-full"
        style={{ background: label.color }}
        aria-hidden
      />
      <span style={{ color: label.color }}>{label.text}</span>
      <span className="num text-[var(--color-muted)]">· {received} событий</span>
    </div>
  );
}
